<!-- menu start-->
<ion-grid>
  <ion-row>
    <ion-col size-xs="12" size-md="12" size-lg="12">
      <ion-list class="ion-no-padding" lines="none">
        @for (nav of navs(); track nav.route) {
          <ion-item
            class="panel-menu-item"
            [class.active]="isActive(nav.route) || nav.color === 'primary'"
            (click)="menuItemClick(nav.route)"
            [color]="nav.color"
          >
            {{ nav.label | translate }}
          </ion-item>
        }
      </ion-list>
    </ion-col>
  </ion-row>
</ion-grid>
<!-- menu end-->
